export const pollDefaults = {
    name: '',
    title: '',
    description: '',
    notice: '',
    startedAt: null,
    closedAt: null,
    tags: [],
    settings: {
        nextStartAt: null,
        nextStopAt: null,
        access: {
            passwords: [],
            iframeAllowedFrom: [],
            ipWhitelist: [],
            ipBlacklist: []
        },
    }
};